import {observer} from 'mobx-react-lite'
import {useState} from 'react'
import React from 'react'
import {Lang} from 'yougile-lang'
import {DataObjectId} from 'yougile-model'
import {DropdownContent} from '@components/common/dropdown/dropdown-content'
import {DropdownIcon} from '@components/common/dropdown-list/dropdown-button'
import {ProjectsFlatTree} from '@components/common/projects-tree/projects-tree'
import {Tooltip} from '@components/common/tooltip/tooltip'
import NoBoardIcon from '@components/subtasks-old/no-board.svg'

export const NoBoard = observer(
  (props: {setLocation: (id: DataObjectId) => void; isSubtask?: boolean}) => {
    const [showPlacement, setShowPlacement] = useState(false)
    return (
      <DropdownIcon
        content={
          <DropdownContent
            disableHeaderMargin={true}
            header={Lang.msg.subtask.placement}
          >
            <ProjectsFlatTree
              onChange={id => {
                props.setLocation(id)
                setShowPlacement(false)
              }}
            />
          </DropdownContent>
        }
        className="relative mr-8 -ml-2 top-2"
        open={showPlacement}
        onOpenChange={setShowPlacement}
      >
        <Tooltip
          content={
            props.isSubtask
              ? Lang.msg.subtask.noBoardSubtask
              : Lang.msg.subtask.noBoard
          }
          maxWidth={260}
          placement="bottom-start"
        >
          <NoBoardIcon
            onClick={e => {
              e.stopPropagation()
              setShowPlacement(true)
            }}
          />
        </Tooltip>
      </DropdownIcon>
    )
  }
)
